<template>
  <div class="page flex-col">
    <PageHeader />

    <!-- 顶部通栏 -->
    <ChannelTopBar />

    <!-- 主体内容：1400px 宽度 -->
    <div class="channel-main">
      <!-- 顶部轮播：1400x498 -->
      <div v-if="carouselItems.length > 0">
        <ChannelTwoCarousel :items="carouselItems" />
      </div>

      <!-- 双列新闻列表 -->
      <ChannelTwoNews  v-if="carouselLoaded" :category-id="categoryId" :exclude-news-id-list="excludeNewsIdList" />
    </div>

    <PageFooter />

    <!-- ================= 回到顶部按钮 ================= -->
    <button 
      v-show="showBackToTop" 
      class="back-to-top" 
      @click="scrollToTop"
      title="回到顶部"
      aria-label="回到顶部"
    >
      <!-- 使用你提供的图片链接 -->
      <img 
        src="https://image.cbrand.com.cn/default/2026/10/2D3A47A40740459C98A490CF835B4529.png" 
        alt="回到顶部" 
        class="back-to-top-icon"
      />
    </button>
    <!-- =============================================== -->

  </div>
</template>

<script>
import PageHeader from '../detail/components/PageHeader.vue'
import PageFooter from '../detail/components/PageFooter.vue'
import ChannelTopBar from './components/ChannelTopBar.vue'
import ChannelTwoCarousel from './components/ChannelTwoCarousel.vue'
import ChannelTwoNews from './components/ChannelTwoNews.vue'
import { fetchNewsListL2, mapNewsItem } from '../../api'

export default {
  name: 'ChannelTwo',
  components: {
    PageHeader,
    PageFooter,
    ChannelTopBar,
    ChannelTwoCarousel,
    ChannelTwoNews
  },
  data() {
    return {
      categoryId: null,
      carouselItems: [],
      excludeNewsIdList: [],
      carouselLoaded: false, // 标记轮播数据是否加载完成
      
      // 新增：控制回到顶部按钮显示
      showBackToTop: false 
    }
  },
  // 新增：监听滚动事件
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  // 新增：组件销毁前移除监听，防止内存泄漏
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    this.categoryId = this.$route.query.categoryId
    // 使用 nextTick 确保轮播数据和排除列表都已准备好
    this.$nextTick(() => {
      this.loadCarousel()
    })
  },
  methods: {
    // 新增：处理滚动事件
    handleScroll() {
      // 当页面垂直滚动超过 300px 时显示按钮
      this.showBackToTop = window.scrollY > 300
    },
    // 新增：平滑回到顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    async loadCarousel() {
      if (!this.categoryId) return
      try {
        const { list } = await fetchNewsListL2({
          categoryId: this.categoryId,
          isRecommended: 1,
          pageNum: 1,
          pageSize: 5
        })
        this.carouselItems = list.map(mapNewsItem)
        const idList = list.map(item => item.id).filter(Boolean)
        this.excludeNewsIdList = idList
        console.log('[ChannelTwo] loadCarousel, excludeNewsIdList:', idList, 'total items:', list.length)
        
        // 确保在 Vue 响应式更新后将排除列表传递给子组件
        this.$nextTick(() => {
          console.log('[ChannelTwo] excludeNewsIdList 已更新为:', this.excludeNewsIdList)
        })
      } catch (e) {
        console.error('轮播数据加载失败', e)
      }
      finally {
        // 无论成功失败，都放开渲染，防止新闻列表永远不显示
        this.carouselLoaded = true
      }
    }
  }
}
</script>

<style scoped>
.page {
  width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: #fff;
}

.channel-main {
  width: 1400px;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 34px;
}

/* ================= 回到顶部按钮样式 ================= */
.back-to-top {
  position: fixed;    /* 固定定位，不受页面滚动影响 */
  bottom: 50px;       /* 距离屏幕底部 */
  right: 50px;        /* 距离屏幕右侧 */
  width: 54px;
  height: 54px;
  background-color: transparent; /* 背景透明，图片本身带有圆形 */
  border: none;                  /* 移除边框 */
  border-radius: 50%;            /* 圆形点击区域 */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;                  /* 保证在最上层 */
  padding: 0;
  outline: none;
  transition: all 0.3s ease-in-out;
  /* 添加阴影让按钮更立体 */
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
}

/* 按钮内部图片样式 */
.back-to-top-icon {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持图片比例 */
  display: block;
}

/* 鼠标悬停效果 */
.back-to-top:hover {
  transform: scale(1.1); /* 放大 */
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.25)); /* 阴影加深 */
}

/* 点击时的按压效果 */
.back-to-top:active {
  transform: scale(0.95); /* 缩小 */
}
</style>